// UI strings for the be.found.as editor, keyed by the English source string.
// Missing keys fall back to English.
const fr: Record<string, string> = {
  "+ Add cover photo": "+ Ajouter une photo de couverture",
  "A bare domain can't use a CNAME, so it takes two steps. First, if your DNS provider offers an ALIAS or ANAME record (or CNAME flattening), point {domain} at this name — we keep it aimed at our servers, so it never needs updating:":
    "Un domaine nu ne peut pas utiliser de CNAME, il faut donc deux étapes. D'abord, si votre fournisseur DNS propose un enregistrement ALIAS ou ANAME (ou l'aplatissement CNAME), faites pointer {domain} vers ce nom — nous le maintenons dirigé vers nos serveurs, il n'a donc jamais besoin d'être mis à jour :",
  "A domain you own can show this page. Your found.as address keeps working — the domain is an extra way in, and you can remove it anytime.":
    "Un domaine que vous possédez peut afficher cette page. Votre adresse found.as continue de fonctionner — le domaine est un accès supplémentaire, et vous pouvez le retirer à tout moment.",
  "A line or two of text": "Une ligne ou deux de texte",
  "Accent color — left/right arrows change the hue, up/down how colorful":
    "Couleur d'accent — flèches gauche/droite pour changer la teinte, haut/bas pour l'intensité",
  Access: "Accès",
  "Add a name, photo, description, or link.":
    "Ajoutez un nom, une photo, une description ou un lien.",
  "Add a video link.": "Ajoutez un lien vidéo.",
  "Add an image": "Ajouter une image",
  "Add photo": "Ajouter une photo",
  "Add row": "Ajouter une ligne",
  "Add to your page": "Ajouter à votre page",
  Address: "Adresse",
  Advanced: "Avancé",
  "Advanced format": "Format avancé",
  "Allow access": "Autoriser l'accès",
  "Allow pop-ups to open the print page.":
    "Autorisez les pop-ups pour ouvrir la page d'impression.",
  "Any family from the {catalog}. Google is never involved.":
    "N'importe quelle famille du {catalog}. Google n'est jamais sollicité.",
  Authorize: "Autoriser",
  "Auto follows each visitor's device":
    "Auto suit l'appareil de chaque visiteur",
  "Auto follows each visitor's device — check both looks here":
    "Auto suit l'appareil de chaque visiteur — vérifiez les deux rendus ici",
  "Automatic preview image": "Image d'aperçu automatique",
  Background: "Arrière-plan",
  Backup: "Sauvegarde",
  "Blank password — anyone who opens this editor address can change your page.":
    "Mot de passe vide — quiconque ouvre cette adresse d'édition peut modifier votre page.",
  "Blur behind": "Flou derrière",
  "Button text": "Texte du bouton",
  "Button transparency": "Transparence du bouton",
  Buttons: "Boutons",
  "Can't sign in": "Connexion impossible",
  Cancel: "Annuler",
  Canvas: "Canevas",
  "Cards & poster": "Cartes & affiche",
  "Change address": "Changer d'adresse",
  "Change password": "Changer le mot de passe",
  "Check now": "Vérifier maintenant",
  "Checking availability…": "Vérification de la disponibilité…",
  "Checking this sign-in request…":
    "Vérification de cette demande de connexion…",
  "Choose a file under 5MB.": "Choisissez un fichier de moins de 5 Mo.",
  Circle: "Cercle",
  Close: "Fermer",
  Colors: "Couleurs",
  Connect: "Connecter",
  "Contact buttons": "Boutons de contact",
  "Contact card": "Carte de contact",
  "Contact page": "Page de contact",
  "Contact page editor": "Éditeur de page de contact",
  Content: "Contenu",
  Continue: "Continuer",
  "Continue as {identity}": "Continuer en tant que {identity}",
  "Copied as plain text": "Copié en texte brut",
  "Copied ✓": "Copié ✓",
  Copy: "Copier",
  "Copy link": "Copier le lien",
  "Copy plain text": "Copier le texte brut",
  "Copy signature": "Copier la signature",
  "Copy {type} value": "Copier la valeur {type}",
  "Copy, then paste into your email app's signature settings.":
    "Copiez, puis collez dans les réglages de signature de votre application e-mail.",
  Corners: "Angles",
  "Could not compress that image.": "Impossible de compresser cette image.",
  "Could not prepare the icon.": "Impossible de préparer l'icône.",
  "Could not prepare the image.": "Impossible de préparer l'image.",
  "Could not read that icon.": "Impossible de lire cette icône.",
  "Could not read that image.": "Impossible de lire cette image.",
  "Could not read the image.": "Impossible de lire l'image.",
  "Couldn't render the social preview image — publishing the page without it.":
    "Impossible de générer l'image d'aperçu social — la page est publiée sans elle.",
  Cover: "Couverture",
  "Choose a password": "Choisissez un mot de passe",
  "Create page": "Créer la page",
  "Cropped to 1200×630 and served with your page. Until you add one, links share without an image.":
    "Recadrée en 1200×630 et servie avec votre page. Tant que vous n'en ajoutez pas, les liens se partagent sans image.",
  "Custom link": "Lien personnalisé",
  "Custom preview image": "Image d'aperçu personnalisée",
  "Custom preview image that will be published":
    "Image d'aperçu personnalisée qui sera publiée",
  Dark: "Sombre",
  "Darken by": "Assombrir de",
  "Delete page": "Supprimer la page",
  "Delete permanently": "Supprimer définitivement",
  "Design sections": "Sections de design",
  "Domain you own": "Domaine que vous possédez",
  Dots: "Points",
  "Drag to reorder": "Glissez pour réorganiser",
  "Drag to resize the preview": "Glissez pour redimensionner l'aperçu",
  "Edit page": "Modifier la page",
  Email: "E-mail",
  "Email signature": "Signature e-mail",
  "Emoji icon": "Icône emoji",
  "Enter a Bluesky handle or link.":
    "Saisissez un identifiant ou un lien Bluesky.",
  "Enter a Bluesky handle.": "Saisissez un identifiant Bluesky.",
  "Enter a Cash App cashtag or link.":
    "Saisissez un cashtag ou un lien Cash App.",
  "Enter a Cash App cashtag.": "Saisissez un cashtag Cash App.",
  "Enter a Mastodon address or link.":
    "Saisissez une adresse ou un lien Mastodon.",
  "Enter a Matrix ID or link.": "Saisissez un identifiant ou un lien Matrix.",
  "Enter a Substack name or link.": "Saisissez un nom ou un lien Substack.",
  "Enter a WhatsApp phone number.":
    "Saisissez un numéro de téléphone WhatsApp.",
  "Enter a YouTube, Vimeo, or PeerTube link.":
    "Saisissez un lien YouTube, Vimeo ou PeerTube.",
  "Enter a domain like yourname.com.":
    "Saisissez un domaine comme yourname.com.",
  "Enter a phone number.": "Saisissez un numéro de téléphone.",
  "Enter a redirect destination before publishing.":
    "Saisissez une destination de redirection avant de publier.",
  "Enter a valid Bluesky link.": "Saisissez un lien Bluesky valide.",
  "Enter a valid Cash App link.": "Saisissez un lien Cash App valide.",
  "Enter a valid Mastodon link.": "Saisissez un lien Mastodon valide.",
  "Enter a valid Matrix link.": "Saisissez un lien Matrix valide.",
  "Enter a valid Substack link.": "Saisissez un lien Substack valide.",
  "Enter a valid email address.": "Saisissez une adresse e-mail valide.",
  "Enter a valid map link.": "Saisissez un lien de carte valide.",
  "Enter a valid redirect destination before publishing.":
    "Saisissez une destination de redirection valide avant de publier.",
  "Enter a valid web address.": "Saisissez une adresse web valide.",
  "Enter a valid {label} link.": "Saisissez un lien {label} valide.",
  "Enter a valid {service} link.": "Saisissez un lien {service} valide.",
  "Enter a {label} link.": "Saisissez un lien {label}.",
  "Enter a {service} username or link.":
    "Saisissez un nom d'utilisateur ou un lien {service}.",
  "Enter a {service} username.": "Saisissez un nom d'utilisateur {service}.",
  "Enter an Instagram username or link.":
    "Saisissez un nom d'utilisateur ou un lien Instagram.",
  "Enter an address or map link.": "Saisissez une adresse ou un lien de carte.",
  "Enter an email address.": "Saisissez une adresse e-mail.",
  "Enter an https:// {label} link.": "Saisissez un lien {label} en https://.",
  "Enter the existing password": "Saisissez le mot de passe actuel",
  "Export backup (.zip)": "Exporter la sauvegarde (.zip)",
  Fallback: "Repli",
  "Favicon emoji": "Emoji de favicon",
  "Feature this link": "Mettre ce lien en avant",
  Featured: "En vedette",
  "Featured — hidden until complete.":
    "En vedette — masqué jusqu'à ce qu'il soit complet.",
  File: "Fichier",
  "File to publish": "Fichier à publier",
  Fill: "Remplir",
  Filled: "Plein",
  "Finish the Instagram link or username.":
    "Complétez le lien ou le nom d'utilisateur Instagram.",
  "Finish the {label} link.": "Complétez le lien {label}.",
  "Fit whole image": "Image entière",
  Font: "Police",
  Forget: "Oublier",
  "Forget on this device": "Oublier sur cet appareil",
  "Format the text": "Mettre en forme le texte",
  "Found it! Securing {domain} — this usually takes under a minute…":
    "Trouvé ! Sécurisation de {domain} — cela prend généralement moins d'une minute…",
  "Google Fonts catalog ↗": "catalogue Google Fonts ↗",
  "Google review": "Avis Google",
  Gradient: "Dégradé",
  Grid: "Grille",
  "HTML content": "Contenu HTML",
  Heading: "Titre",
  Height: "Hauteur",
  "Hidden until complete.": "Masqué jusqu'à ce qu'il soit complet.",
  "Hidden until it has text.": "Masqué tant qu'il n'a pas de texte.",
  "Hidden.": "Masqué.",
  Hide: "Masquer",
  "Host one file up to 5MB.": "Hébergez un fichier jusqu'à 5 Mo.",
  "Icon lookup failed ({status}).": "La recherche d'icône a échoué ({status}).",
  "Icon saved into your page.": "Icône enregistrée dans votre page.",
  "Import backup": "Importer une sauvegarde",
  "Import icon": "Importer l'icône",
  "Imported — review and publish to make it live.":
    "Importé — vérifiez et publiez pour le mettre en ligne.",
  "Importing…": "Importation…",
  "In your Google Business Profile, use “Ask for reviews” to copy your review link — it looks like":
    "Dans votre fiche Google Business Profile, utilisez « Demander des avis » pour copier votre lien d'avis — il ressemble à",
  "Include on business cards": "Inclure sur les cartes de visite",
  Language: "Langue",
  "Lets visitors download a contact card (.vcf). It appears once the page has a name and a shown phone or email.":
    "Permet aux visiteurs de télécharger une carte de contact (.vcf). Elle apparaît dès que la page a un nom et un téléphone ou e-mail affiché.",
  Light: "Clair",
  "Lighten by": "Éclaircir de",
  "Links for web, email, social, phone, and more.":
    "Des liens web, e-mail, réseaux sociaux, téléphone et plus.",
  "Loading…": "Chargement…",
  Looks: "Apparences",
  "Lowercase letters, numbers and hyphens make the best address — capitals and special characters are harder to type and share.":
    "Minuscules, chiffres et tirets font la meilleure adresse — majuscules et caractères spéciaux sont plus difficiles à taper et à partager.",
  "Main address": "Adresse principale",
  "Manage domains": "Gérer les domaines",
  "Markdown content": "Contenu Markdown",
  "Markdown: {bold}, {italic}, links, lists and headings.":
    "Markdown : {bold}, {italic}, liens, listes et titres.",
  "Mathematician · first computer programmer":
    "Mathématicienne · première programmeuse informatique",
  "Move page": "Déplacer la page",
  "Move {label} down": "Descendre {label}",
  "Move {label} up": "Monter {label}",
  Name: "Nom",
  "Need a public email address? Create a forwarding alias at":
    "Besoin d'une adresse e-mail publique ? Créez un alias de transfert sur",
  "New address": "Nouvelle adresse",
  "New page path": "Nouveau chemin de page",
  "New password": "Nouveau mot de passe",
  "No ALIAS support? Use a subdomain like {www} instead — it takes a plain CNAME.":
    "Pas de support ALIAS ? Utilisez plutôt un sous-domaine comme {www} — un simple CNAME suffit.",
  "No contact buttons yet.": "Pas encore de boutons de contact.",
  "No icon found for that site.": "Aucune icône trouvée pour ce site.",
  "No priv.cbor found in this file.": "Aucun priv.cbor trouvé dans ce fichier.",
  None: "Aucun",
  "Not a ZIP file.": "Ce n'est pas un fichier ZIP.",
  "Now at found.as/{target}.": "Désormais sur found.as/{target}.",
  "On a subdomain instead (like www.{domain})?":
    "Plutôt sur un sous-domaine (comme www.{domain}) ?",
  "One CNAME on {domain} pointing to the address above. It connects the domain and proves it's yours in a single record.":
    "Un seul CNAME sur {domain} pointant vers l'adresse ci-dessus. Il connecte le domaine et prouve qu'il est à vous en un seul enregistrement.",
  "Online in seconds": "En ligne en quelques secondes",
  Open: "Ouvrir",
  "Open your public page": "Ouvrir votre page publique",
  "Optional line under the button": "Ligne facultative sous le bouton",
  "Or upload a separate dark image": "Ou téléversez une image sombre distincte",
  Outline: "Contour",
  "Page link": "Lien de la page",
  "Page password": "Mot de passe de la page",
  "Page path": "Chemin de la page",
  "Page preview": "Aperçu de la page",
  "Page type": "Type de page",
  "Password changed — save a fresh recovery kit.":
    "Mot de passe changé — enregistrez un nouveau kit de récupération.",
  "Paste a valid Google review link.": "Collez un lien d'avis Google valide.",
  "Paste your Google review link.": "Collez votre lien d'avis Google.",
  Phone: "Téléphone",
  "Photo shape": "Forme de la photo",
  "Pick an address and a password. No account, no cookies.":
    "Choisissez une adresse et un mot de passe. Pas de compte, pas de cookies.",
  Pill: "Pilule",
  Platforms: "Plateformes",
  "Preparing…": "Préparation…",
  Preview: "Aperçu",
  "Preview appearance": "Apparence de l'aperçu",
  "Preview description": "Description de l'aperçu",
  "Preview fallback": "Aperçu de repli",
  "Preview image appearance": "Apparence de l'image d'aperçu",
  "Preview image that will be published": "Image d'aperçu qui sera publiée",
  "Preview title": "Titre de l'aperçu",
  "Profile email": "E-mail du profil",
  Publish: "Publier",
  "Publish a custom HTML page.": "Publiez une page HTML personnalisée.",
  "Publish to {host}": "Publier sur {host}",
  "QR code type": "Type de QR code",
  Redirect: "Redirection",
  "Redirect destination": "Destination de la redirection",
  "Redirect, markdown page, HTML page, or file.":
    "Redirection, page Markdown, page HTML ou fichier.",
  "Refresh icon": "Actualiser l'icône",
  "Remember on this device": "Mémoriser sur cet appareil",
  "Remembered on this device": "Mémorisé sur cet appareil",
  Remove: "Retirer",
  "Remove dark image": "Retirer l'image sombre",
  "Remove icon": "Retirer l'icône",
  "Remove {label}": "Retirer {label}",
  Replace: "Remplacer",
  "Replace dark image": "Remplacer l'image sombre",
  "Replace image": "Remplacer l'image",
  Rounded: "Arrondie",
  "Rounded square": "Carré arrondi",
  Save: "Enregistrer",
  "Save QR": "Enregistrer le QR",
  "Save QR code": "Enregistrer le QR code",
  "Save contact": "Enregistrer le contact",
  "Save contact button label": "Libellé du bouton d'enregistrement du contact",
  "Save recovery kit": "Enregistrer le kit de récupération",
  "Saves this page's key in this browser so future sign-ins skip the password. Only on a device you trust.":
    "Enregistre la clé de cette page dans ce navigateur pour que les prochaines connexions se passent de mot de passe. Uniquement sur un appareil de confiance.",
  "Saves this page's key in this browser so it opens without the password. Only on a device you trust.":
    "Enregistre la clé de cette page dans ce navigateur pour qu'elle s'ouvre sans mot de passe. Uniquement sur un appareil de confiance.",
  "Search fonts…": "Rechercher une police…",
  "Section header": "En-tête de section",
  "Send visitors to one web address.":
    "Envoyez les visiteurs vers une adresse web.",
  Share: "Partager",
  Sharing: "Partage",
  Sharp: "Droits",
  "Short description": "Courte description",
  Show: "Afficher",
  "Show an icon on this button — type an emoji, or import the site's icon. It's fetched once and saved into your page.":
    "Affichez une icône sur ce bouton — tapez un emoji, ou importez l'icône du site. Elle est récupérée une fois et enregistrée dans votre page.",
  "Show an icon on this button — type any emoji.":
    "Affichez une icône sur ce bouton — tapez n'importe quel emoji.",
  "Show on page": "Afficher sur la page",
  "Shown as a heading.": "Affiché comme un titre.",
  "Shown as a video.": "Affiché comme une vidéo.",
  "Shown as text.": "Affiché comme du texte.",
  "Shown in the browser tab.": "Affiché dans l'onglet du navigateur.",
  "Sign in": "Se connecter",
  "Sign in wherever you manage {domain}'s DNS — usually where you bought it — and add a CNAME record:":
    "Connectez-vous là où vous gérez le DNS de {domain} — généralement là où vous l'avez acheté — et ajoutez un enregistrement CNAME :",
  "Sign-in": "Connexion",
  "Signature preview": "Aperçu de la signature",
  "Signing in…": "Connexion…",
  Soft: "Doux",
  "Start writing GitHub-flavored markdown.\n\nOptional front matter:\n---\ntitle: Page title\n---":
    "Commencez à écrire du Markdown façon GitHub.\n\nFront matter facultatif :\n---\ntitle: Titre de la page\n---",
  "Start writing HTML": "Commencez à écrire du HTML",
  "Status line": "Ligne de statut",
  Subtitle: "Sous-titre",
  System: "Système",
  "TXT record": "Enregistrement TXT",
  Text: "Texte",
  "That file is over 5MB. Choose a smaller file.":
    "Ce fichier dépasse 5 Mo. Choisissez un fichier plus petit.",
  "That icon is too large.": "Cette icône est trop volumineuse.",
  "That password doesn't match this page.":
    "Ce mot de passe ne correspond pas à cette page.",
  "That site did not return an icon.": "Ce site n'a pas renvoyé d'icône.",
  "The address featured on your QR code, printables and email signature. Your page stays reachable at every address either way.":
    "L'adresse mise en avant sur votre QR code, vos imprimés et votre signature e-mail. Votre page reste accessible à toutes les adresses dans tous les cas.",
  Theme: "Thème",
  "Theme default": "Défaut du thème",
  "Then add this record so we know the domain is yours:":
    "Ajoutez ensuite cet enregistrement pour que nous sachions que le domaine est à vous :",
  "There is no password reset. Once you're in, save the recovery kit from the menu — it keeps your address and password somewhere safe.":
    "Il n'y a pas de réinitialisation de mot de passe. Une fois connecté, enregistrez le kit de récupération depuis le menu — il garde votre adresse et votre mot de passe en lieu sûr.",
  "This address already exists — password unlocked. Continue to edit it.":
    "Cette adresse existe déjà — mot de passe déverrouillé. Continuez pour la modifier.",
  "This address exists. Enter its password to edit, or pick another address.":
    "Cette adresse existe. Saisissez son mot de passe pour la modifier, ou choisissez une autre adresse.",
  "This address isn't a found.as page.":
    "Cette adresse n'est pas une page found.as.",
  "This domain is already connected to another page.":
    "Ce domaine est déjà connecté à une autre page.",
  "This is really me": "C'est bien moi",
  "This permanently removes found.as/{path} and releases any custom domains. There's no undo.":
    "Ceci supprime définitivement found.as/{path} et libère les domaines personnalisés. Il n'y a pas de retour en arrière.",
  "This replaces your page's key, so any recovery kit you've saved stops working — save a fresh one afterwards.":
    "Ceci remplace la clé de votre page : tout kit de récupération déjà enregistré cesse de fonctionner — enregistrez-en un nouveau ensuite.",
  "This sign-in request is missing required details.":
    "Il manque des informations requises à cette demande de connexion.",
  "This sign-in request isn't supported.":
    "Cette demande de connexion n'est pas prise en charge.",
  "Type {path} to confirm": "Tapez {path} pour confirmer",
  "Update password": "Mettre à jour le mot de passe",
  "Upload an image": "Téléverser une image",
  "Use @you:server.org, or paste a matrix.to link.":
    "Utilisez @you:server.org, ou collez un lien matrix.to.",
  "Use @you@server, or paste your profile link.":
    "Utilisez @you@server, ou collez le lien de votre profil.",
  "Use the cover as the page's name":
    "Utiliser la couverture comme nom de la page",
  "Use this to edit later": "Utilisez ceci pour modifier plus tard",
  "Using a bare domain like example.com?":
    "Vous utilisez un domaine nu comme example.com ?",
  Video: "Vidéo",
  "Video link": "Lien vidéo",
  "We check every few seconds — you can close this window and come back later.":
    "Nous vérifions toutes les quelques secondes — vous pouvez fermer cette fenêtre et revenir plus tard.",
  "We couldn't secure {domain} after repeated attempts. Remove it, check your DNS records, and try again.":
    "Nous n'avons pas pu sécuriser {domain} malgré plusieurs tentatives. Retirez-le, vérifiez vos enregistrements DNS et réessayez.",
  Website: "Site web",
  "Which address an app receives when someone signs in with your page and allows the email permission.":
    "L'adresse qu'une application reçoit quand quelqu'un se connecte avec votre page et accorde la permission e-mail.",
  Work: "Travail",
  "Working…": "En cours…",
  "Works offline": "Fonctionne hors ligne",
  "Write a simple page with Markdown.": "Écrivez une page simple en Markdown.",
  "You're live 🎉": "Vous êtes en ligne 🎉",
  "Your HTML page is live.": "Votre page HTML est en ligne.",
  "Your address": "Votre adresse",
  "Your contact page is live.": "Votre page de contact est en ligne.",
  "Your file is live.": "Votre fichier est en ligne.",
  "Your markdown page is live.": "Votre page Markdown est en ligne.",
  "Your page moves to the new address. The old one stops working, and any custom domains follow automatically.":
    "Votre page passe à la nouvelle adresse. L'ancienne cesse de fonctionner, et les domaines personnalisés suivent automatiquement.",
  "Your page password": "Le mot de passe de votre page",
  "Your password never leaves this device — it only signs the approval.":
    "Votre mot de passe ne quitte jamais cet appareil — il ne fait que signer l'approbation.",
  "Your redirect is live.": "Votre redirection est en ligne.",
  crimson: "cramoisi",
  "e.g. New": "ex. Nouveau",
  "e.g. ☕": "ex. ☕",
  forest: "forêt",
  "found.as home — switch to another page":
    "accueil found.as — passer à une autre page",
  "found.as/{path} is available.": "found.as/{path} est disponible.",
  gold: "or",
  "hue {hue}°, {pct}% colorful": "teinte {hue}°, {pct}% coloré",
  live: "en ligne",
  "needs attention": "attention requise",
  ocean: "océan",
  rust: "rouille",
  "securing…": "sécurisation…",
  "theme default": "défaut du thème",
  "youtube.com, vimeo.com, or a PeerTube link":
    "youtube.com, vimeo.com ou un lien PeerTube",
  "{client} wants to access your found.as page with these permissions:":
    "{client} souhaite accéder à votre page found.as avec ces permissions :",
  "{client} wants to confirm you own this found.as page.":
    "{client} souhaite confirmer que cette page found.as est à vous.",
  "{domain} isn't connected yet.": "{domain} n'est pas encore connecté.",
  "{index} of {total}": "{index} sur {total}",
  "{link} is live.": "{link} est en ligne.",
  "{name} is ready to publish.": "{name} est prêt à être publié.",
  "▶ Add a video": "▶ Ajouter une vidéo",
  "✓ We can see your proof record — now waiting for {domain} to route to us, usually just the DNS change spreading.":
    "✓ Nous voyons votre enregistrement de preuve — nous attendons maintenant que {domain} soit routé vers nous, généralement le temps que le changement DNS se propage.",
  "✓ {domain} is reaching us. Now add the record that proves it's yours — the {record} below.":
    "✓ {domain} nous atteint. Ajoutez maintenant l'enregistrement qui prouve qu'il est à vous — le {record} ci-dessous.",
  "🟢 Status (optional)": "🟢 Statut (facultatif)",
};

export default fr;
